module.exports = __webpack_public_path__ + "assets/backbonejs.4c822648.svg";